import React from 'react';
import { buildClassName } from 'utils/build-class-name';
import { getColourOfStat } from 'utils/data-vis-helpers';
import styles from './style.module.scss';
import { TryScrambleText } from 'utils/text-scrambler';

export interface Props {
  isBlurred: boolean;
  chartTitle: string;
  chartDescription: string;
  cityName: string;
  cityStat: string | number;
  cityYoYStat: string | number;
  neighbourhoodName: string;
  neighbourhoodStat: string | number;
  neighbourhoodYoYStat: string | number;
  hideYoYStat?: boolean;
  hideNeighbourhoodYoYStats?: boolean;
}

export default function TopSectionStats({ isBlurred, chartTitle, chartDescription, cityName, cityStat, cityYoYStat, neighbourhoodName, neighbourhoodStat, neighbourhoodYoYStat, hideYoYStat, hideNeighbourhoodYoYStats }: Props) {
  return (
    <div>
      <div className={styles.info}>
        <div className={styles['chart-title']}>
          {chartTitle}
        </div>
        <div className={styles['chart-description']}>
          {chartDescription}
        </div>
        <div className={styles.stat}>
          <span>
            <div className={styles.label}>
              {cityName}
            </div>
            <div className={isBlurred ? 'blur' : styles.value}>
              {TryScrambleText(cityStat, isBlurred)}
            </div>
          </span>
          {!hideYoYStat &&
            <span>
              <div className={buildClassName(styles.label, styles['time-label'])}>
                Year over year
              </div>
              <div className={isBlurred ? 'blur' : styles.value} style={{ color: getColourOfStat(cityYoYStat) }}>
                {Number(cityYoYStat) > 0 ? '+' : ' '}{TryScrambleText(cityYoYStat, isBlurred)}%
              </div>
            </span>
          }
        </div>
      </div>
      {neighbourhoodName && !hideNeighbourhoodYoYStats &&
        <div className={styles.info}>
          <div className={styles.stat}>
            <span>
              <div className={styles.label}>
                {neighbourhoodName}
              </div>
              <div className={isBlurred ? 'blur' : styles.value} >
                {TryScrambleText(neighbourhoodStat, isBlurred)}
              </div>
            </span>
            <span>
              <div className={buildClassName(styles.label, styles['time-label'])}>
                Year over year
              </div>
              <div className={isBlurred ? 'blur' : styles.value} style={{ color: getColourOfStat(neighbourhoodYoYStat) }}>
                {Number(neighbourhoodYoYStat) > 0 ? '+' : ' '}{TryScrambleText(neighbourhoodYoYStat, isBlurred)}%
              </div>
            </span>
          </div>
        </div>
      }
    </div>
  );
}
